"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source))).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

var PropTypes = require("prop-types");

var React = require("react"),
    classnames = require("classnames"),
    Button = require("../buttons/Button"),
    MessageTypes = require("../general/messages/MessagesConstants").MessageTypes;
/**
 * @callback InlineMessage~onClick
 * @param {object} e
 *          The ReactJS synthetic event object
 */

/**
 * @typedef {Object} InlineMessage~primaryButton
 * @property {string} [href]
 *     Pass in a string to give the button an href.
 * @property {string} [target]
 *     Pass a string to give the button a target.
 */

/**
 * @typedef {Object} InlineMessage~secondaryButtons
 * @property {string} [className]
 *     CSS classes to add on the top-level HTML container.
 * @property {string} [label]
 *     Pass in a string label for the button label if you want an action option. If you pass this you must
 *     also pass the callback function.
 * @property {InlineMessage~onClick} [onClick]
 *     Callback to be triggered when the button is clicked.
 */

/**
 * @class InlineMessage
 * @desc Sometimes we need a message block to show embedded in a form or somewhere on a page.
 *
 * @param {boolean} [alternate]
 *     Warning message with full background color and no icon.
 * @param {boolean} [bordered=true]
 *     Whether or not to surround the inline message with a border.
 * @param {string} [className]
 *     CSS classes to add on the top-level HTML container.
 * @param {string} [data-id="inline-message"]
 *     To define the base "data-id" value for the top-level HTML container.
 * @param {boolean} [fullwidth]
 *     when true creates a full page width inline message.
 * @param {string} [label]
 *     Pass in a string label for the button label if you want an action option. If you pass this you must
 *     also pass the callback function.
 * @param {boolean} [noMargin]
 *     When true it will remove the margin around the inline message.
 * @param {InlineMessage~onClick} [onClick]
 *     Callback to be triggered when the button is clicked.
 * @param {InlineMessage~primaryButton} [primaryButton]
 *      Primary button containing href and target.
 * @param {Array.<InlineMessage~secondaryButtons>} [secondaryButtons]
 *     List of secondary buttons
 * @param {Messages.MessageTypes} [type=MessageTypes.NOTICE]
 *     Type of icon to display (MessageTypes.NOTICE, MessageTypes.ERROR, MessageTypes.WARNING)
 *     an object for the primary button
 *
 *
 * @example
 *     No action button button:
 *     <InlineMessage data-id="notice-message-no-button" type={ InlineMessage.MessageTypes.NOTICE }>
 *         Your message here
 *     </InlineMessage>
 *     With a button:
 *     <InlineMessage data-id="notice-message-button" type={ InlineMessage.MessageTypes.NOTICE }
 *         label="Do Something" onClick={doSomething}>
 *         Your message here
 *     </InlineMessage>
 */


var InlineMessage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(InlineMessage, _React$Component);

  var _super = _createSuper(InlineMessage);

  function InlineMessage() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, InlineMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_showAction", function () {
      return _this.props.label !== undefined && _this.props.onClick !== undefined;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onClick", function (onClick) {
      return function (e) {
        onClick(e);
      };
    });
    return _this;
  }

  (0, _createClass2.default)(InlineMessage, [{
    key: "render",
    value: function render() {
      var _context2,
          _context3,
          _this2 = this;

      var className = classnames("inline-message", this.props.type, {
        "inline-message--borderless": !this.props.bordered,
        "inline-message--alternate": this.props.alternate,
        "inline-message--fullwidth": this.props.fullwidth,
        "inline-message--nomargin": this.props.noMargin
      });
      var messageClassName = classnames("inline-message-text", {
        "inline-message-text--full-width": this.props.fullwidth
      });
      return /*#__PURE__*/React.createElement("div", {
        "data-id": this.props["data-id"],
        className: classnames(className, this.props.className)
      }, /*#__PURE__*/React.createElement("div", {
        "data-id": "inline-message-text",
        className: messageClassName
      }, this.props.children), this._showAction() && (0, _map.default)(_context2 = (0, _concat.default)(_context3 = [_objectSpread(_objectSpread({
        label: this.props.label,
        onClick: this.props.onClick
      }, this.props.primaryButtonProps), {}, {
        className: "primary"
      })]).call(_context3, this.props.secondaryButtons)).call(_context2, function (_ref, index) {
        var _context4;

        var onClick = _ref.onClick,
            label = _ref.label,
            href = _ref.href,
            target = _ref.target,
            type = _ref.type,
            buttonClass = _ref.className;
        return /*#__PURE__*/React.createElement("div", {
          key: (0, _concat.default)(_context4 = "".concat(label, "-")).call(_context4, index),
          "data-id": "inline-message-btn",
          className: "inline-message-btn"
        }, /*#__PURE__*/React.createElement(Button, {
          key: "main",
          inline: true,
          type: type,
          label: label,
          onClick: _this2._onClick(onClick),
          className: buttonClass,
          href: href,
          target: target
        }));
      }));
    }
  }]);
  return InlineMessage;
}(React.Component);

(0, _defineProperty3.default)(InlineMessage, "propTypes", {
  alternate: PropTypes.bool,
  fullwidth: PropTypes.bool,
  bordered: PropTypes.bool,
  className: PropTypes.string,
  "data-id": PropTypes.string,
  noMargin: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  type: PropTypes.oneOf([MessageTypes.NOTICE, MessageTypes.ERROR, MessageTypes.WARNING, MessageTypes.SUCCESS]),
  primaryButtonProps: PropTypes.shape({
    href: PropTypes.string,
    target: PropTypes.string
  }),
  secondaryButtons: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired
  }))
});
(0, _defineProperty3.default)(InlineMessage, "defaultProps", {
  "data-id": "inline-message",
  fullWidth: false,
  noMargin: false,
  bordered: true,
  type: MessageTypes.NOTICE,
  primaryButton: {},
  secondaryButtons: []
});
InlineMessage.MessageTypes = MessageTypes;
InlineMessage.messageTypes = MessageTypes; // new standard

module.exports = InlineMessage;